<template>
  <div class="notification notification_component"
       :class="getClass"
  >
    <div class="notification_block">
      <div class="notification_image">

        <!-- successfully -->
        <div class="notification_svg notification_svg__green"
             v-if="typeNotification === 'successfully'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.80075 14.3095L6.60056 11.1093L6.50775 11.0165L6.41494 11.1093L5.00094 12.5233L4.90813 12.6161L5.00094 12.709L9.70794 17.416L9.80075 17.5088L9.89356 17.416L19.6006 7.70896L19.6934 7.61615L19.6006 7.52334L18.1866 6.10934L18.0938 6.01653L18.0009 6.10934L9.80075 14.3095Z" fill="#89CE54" stroke="#89CE54" stroke-width="0.2625"/>
          </svg>
        </div>

        <!-- error -->
        <div class="notification_svg notification_svg__red"
             v-else-if="typeNotification === 'error'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.80075 14.3095L6.60056 11.1093L6.50775 11.0165L6.41494 11.1093L5.00094 12.5233L4.90813 12.6161L5.00094 12.709L9.70794 17.416L9.80075 17.5088L9.89356 17.416L19.6006 7.70896L19.6934 7.61615L19.6006 7.52334L18.1866 6.10934L18.0938 6.01653L18.0009 6.10934L9.80075 14.3095Z" fill="#89CE54" stroke="#89CE54" stroke-width="0.2625"/>
          </svg>
        </div>

        <!-- attention -->
        <div class="notification_svg notification_svg__yellow"
             v-else-if="typeNotification === 'attention'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8843 1.99157C12.5383 1.33614 11.4623 1.33614 11.1163 1.99157L2.11625 19.0288C1.95225 19.3395 1.96225 19.7143 2.14325 20.0139C2.32425 20.3156 2.64925 20.5 3.00025 20.5H21.0004C21.3514 20.5 21.6764 20.3156 21.8564 20.0149C22.0384 19.7143 22.0474 19.3395 21.8834 19.0298L12.8843 1.99157ZM13.0003 17.4934H11.0003V15.4891H13.0003V17.4934ZM11.0003 13.4847V8.47373H13.0003L13.0013 13.4847H11.0003Z" fill="#FFB800"/>
          </svg>
        </div>

        <!-- cookies -->
        <div class="notification_svg notification_svg__cookies"
             v-else-if="typeNotification === 'cookies'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.5981 11.0641C21.4777 10.9733 21.3385 10.9107 21.1907 10.8809C21.0428 10.8511 20.8902 10.8549 20.7441 10.8921C20.5017 10.9598 20.2517 10.9961 20.0001 11.0001C18.3461 11.0001 17.0001 9.65411 16.9971 8.06211C17.0021 8.02811 17.0131 7.92811 17.0141 7.89411C17.0206 7.73778 16.9903 7.5821 16.9255 7.43964C16.8608 7.29719 16.7635 7.17195 16.6414 7.07403C16.5194 6.97612 16.376 6.90828 16.2229 6.87598C16.0698 6.84368 15.9113 6.84784 15.7601 6.88811C15.5126 6.95784 15.2572 6.99548 15.0001 7.00011C13.3461 7.00011 12.0001 5.65411 12.0001 4.00011C12.0001 3.78311 12.0311 3.55611 12.0991 3.28411C12.1376 3.12886 12.1383 2.96663 12.1011 2.81105C12.0639 2.65547 11.99 2.51108 11.8854 2.39C11.7809 2.26891 11.6489 2.17467 11.5004 2.11518C11.3519 2.0557 11.1913 2.0327 11.0321 2.04811C8.55554 2.27893 6.2551 3.42838 4.58353 5.27022C2.91196 7.11205 1.99034 9.51286 2.00008 12.0001C2.00008 17.5141 6.48608 22.0001 12.0001 22.0001C17.5141 22.0001 22.0001 17.5141 22.0001 12.0001C22.0001 11.9511 21.9971 11.9031 21.9931 11.8401C21.9897 11.6894 21.9525 11.5414 21.8841 11.4071C21.8157 11.2727 21.7179 11.1555 21.5981 11.0641ZM8.50008 6.00011C8.8979 6.00011 9.27943 6.15815 9.56074 6.43945C9.84204 6.72076 10.0001 7.10229 10.0001 7.50011C10.0001 7.89794 9.84204 8.27947 9.56074 8.56077C9.27943 8.84208 8.8979 9.00011 8.50008 9.00011C8.10225 9.00011 7.72072 8.84208 7.43942 8.56077C7.15811 8.27947 7.00008 7.89794 7.00008 7.50011C7.00008 7.10229 7.15811 6.72076 7.43942 6.43945C7.72072 6.15815 8.10225 6.00011 8.50008 6.00011ZM6.50008 14.0001C6.30309 14.0001 6.10804 13.9613 5.92605 13.8859C5.74406 13.8106 5.5787 13.7001 5.43942 13.5608C5.30013 13.4215 5.18964 13.2561 5.11426 13.0741C5.03887 12.8921 5.00008 12.6971 5.00008 12.5001C5.00008 12.3031 5.03887 12.1081 5.11426 11.9261C5.18964 11.7441 5.30013 11.5787 5.43942 11.4395C5.5787 11.3002 5.74406 11.1897 5.92605 11.1143C6.10804 11.0389 6.30309 11.0001 6.50008 11.0001C6.8979 11.0001 7.27943 11.1581 7.56074 11.4395C7.84204 11.7208 8.00008 12.1023 8.00008 12.5001C8.00008 12.8979 7.84204 13.2795 7.56074 13.5608C7.27943 13.8421 6.8979 14.0001 6.50008 14.0001ZM9.50008 18.0001C9.10225 18.0001 8.72072 17.8421 8.43941 17.5608C8.15811 17.2795 8.00008 16.8979 8.00008 16.5001C8.00008 16.1023 8.15811 15.7208 8.43941 15.4395C8.72072 15.1581 9.10225 15.0001 9.50008 15.0001C9.8979 15.0001 10.2794 15.1581 10.5607 15.4395C10.842 15.7208 11.0001 16.1023 11.0001 16.5001C11.0001 16.8979 10.842 17.2795 10.5607 17.5608C10.2794 17.8421 9.8979 18.0001 9.50008 18.0001ZM12.0001 11.5001C12.0001 11.1023 12.1581 10.7208 12.4394 10.4395C12.7207 10.1581 13.1023 10.0001 13.5001 10.0001C13.8979 10.0001 14.2794 10.1581 14.5607 10.4395C14.842 10.7208 15.0001 11.1023 15.0001 11.5001C15.0001 11.8979 14.842 12.2795 14.5607 12.5608C14.2794 12.8421 13.8979 13.0001 13.5001 13.0001C13.1023 13.0001 12.7207 12.8421 12.4394 12.5608C12.1581 12.2795 12.0001 11.8979 12.0001 11.5001ZM15.5001 18.0001C15.1023 18.0001 14.7207 17.8421 14.4394 17.5608C14.1581 17.2795 14.0001 16.8979 14.0001 16.5001C14.0001 16.1023 14.1581 15.7208 14.4394 15.4395C14.7207 15.1581 15.1023 15.0001 15.5001 15.0001C15.8979 15.0001 16.2794 15.1581 16.5607 15.4395C16.842 15.7208 17.0001 16.1023 17.0001 16.5001C17.0001 16.8979 16.842 17.2795 16.5607 17.5608C16.2794 17.8421 15.8979 18.0001 15.5001 18.0001Z" fill="#8C71FE"/>
          </svg>
        </div>
      </div>

      <div class="notification_text"
           v-html="textNotification"
      >
      </div>
    </div>

    <div class="notification_close"
         @click="closeNotification()"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.3755 4.1665L9.99981 8.5415L5.6252 4.1665L4.16699 5.62484L8.54161 9.99984L4.16699 14.3748L5.6252 15.8332L9.99981 11.4582L14.3755 15.8332L15.8337 14.3748L11.459 9.99984L15.8337 5.62484L14.3755 4.1665Z" fill="white" fill-opacity="0.5"/>
      </svg>
    </div>
  </div>
</template>

<script>
import {computed} from "vue";

export default {
  name: "ModalNotification",
  emits: ['close'],
  props: {
    timeShowNotification: {  // -1 - модальное окно не закрывается по прошествию n-го времени / время в секундах
      type: Number,
      default: () => {
        return -1
      }
    },
    textNotification: { // текст уведомления
      type: String,
      default: () => {
        return ''
      }
    },
    typeNotification: {
      type: String,  // successfully - успешно / error - ошибка / cookies - уведомление о куки / attention - внимание
      default: () => {
        return 'successfully'
      }
    }
  },

  setup(props, { emit }) {

    let closeNotification = () => { // закрыть окно уведомления
      emit('close');
    }

    let getClass = computed(() => {
      let classReturn = 'notification__';

      switch (props.typeNotification) {
        case 'successfully':
          classReturn += 'green';
          break;

        case 'error':
          classReturn += 'red';
          break;

        case 'attention':
          classReturn += 'yellow';
          break;

        case 'cookies':
          classReturn += 'purple';
          break;
      }

      return classReturn
    })

    if (props.timeShowNotification !== -1) {
      setTimeout(() => {
        closeNotification();
      }, props.timeShowNotification*1000)
    }

    return {
      getClass,
      closeNotification,
    }
  },

  components: {

  }
}
</script>

<style lang="scss">
  .notification .notification_text a {
    color: white;
  }
</style>

<style scoped lang="scss">
@import "../../../styles/variables.scss";

.notification .notification_text {
  a {
    cursor: pointer;
    text-decoration: underline;
    color: white;
  }
}

.notification {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-family: $font_Geometria;
  color: $color_black;
  position: fixed;
  bottom: 56px;
  left: calc((100vw / 2) - (750px/2));
  padding: 14px 20px;
  width: 710px;
  transition: $transition_medium;
  box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
  border-radius: 16px;
  z-index: 21;
}

.notification_block {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.notification__green {
  background-color: $color_green_1;
}

.notification__red {
  background-color: $color_red_1;
}

.notification__purple {
  background-color: $color_purple_3;
}

.notification__yellow {
  background-color: $color_yellow_1;
}

.notification_image {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: $transition_medium;
  background-color: white;
}

.notification_svg {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: $transition_medium;

  svg {
    width: 24px;
    height: 24px;
    transition: $transition_medium;
  }
}

.notification_svg__green {
  svg path {
    fill: $color_green_1;
  }
}

.notification_svg__red {
  svg path {
    fill: $color_red_1;
  }
}

.notification_svg__purple {
  svg path {
    fill: $color_purple_1;
  }
}

.notification_svg__yellow {
  svg path {
    fill: $color_yellow_1;
  }
}

.notification_text {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: white;
  margin: 0 20px 0 12px;
}

.notification_close {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg path {
    transition: $transition_medium;
  }

  &:hover {
    svg path {
      fill-opacity: 1;
    }
  }
}

@media all and (max-width: 1800px) {
  .notification {
    bottom: 48px;
  }
}

@media all and (max-width: 1600px) {

}

@media all and (max-width: 1440px) {
  .notification {
    bottom: 34px;
    padding: 13px 18px;
    border-radius: 10px;
    left: calc((100vw / 2) - (706px/2));
    width: 670px;
  }

  .notification_image {
    width: 34px;
    height: 34px;
    min-width: 34px;
    min-height: 34px;
  }

  .notification_svg svg {
    width: 18px;
    height: 18px;
  }

  .notification_text {
    font-size: 15px;
    line-height: 19px;
    margin: 0 14px 0 10px;
  }

}

@media all and (max-width: 1280px) {

}

@media all and (max-width: 1160px) {
  .notification {
    bottom: 118px;
  }

}

@media all and (max-width: 960px) {
  .notification {
    /*left: 30px;
    width: calc(100% - 30px - 30px - 36px);*/
  }
}

@media all and (max-width: 768px) {
  .notification {
    left: 30px;
    width: calc(100% - 28px - 60px);
    border-radius: 8px;
    bottom: 79px;
    padding: 12px 14px;
  }

  .notification_image {
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
  }

  .notification_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    margin: 0 12px 0 8px;
  }
}

@media all and (max-width: 600px) {
  .notification {
    left: 15px;
    width: calc(100% - 28px - 30px);
  }
}

@media all and (max-width: 360px) {

}

</style>